import Auth from "@aws-amplify/auth";

export type UnauthorizedRequestAction = () => void;

let unauthorizedRequestAction: UnauthorizedRequestAction;

export const setUnauthorizedRequestAction = (
  action: UnauthorizedRequestAction
): void => {
  unauthorizedRequestAction = action;
};

export const unauthorizedAction = () => {
  Auth.signOut();
  localStorage.setItem("authToken", "");
  localStorage.setItem("user", "");
  location.replace("/");
  // if (unauthorizedRequestAction) {
  //     unauthorizedRequestAction();
  // }
};
